import axios from 'axios';

export const AtiraApi = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    'X-Atria-header': 'true',
    'x-atria-test-header': process.env.NODE_ENV === 'test' ? 'true' : undefined,
    'x-atria-test-secret': process.env.E2E_SECRET,
  },
});

AtiraApi.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem(
      process.env.REACT_APP_LOCAL_STORAGE_TOKEN_KEY!,
    );

    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error),
);

AtiraApi.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      // Token expired
      // The server will send 401 response if the token is invalid or expired

      const store = await import('../redux/store').then((m) => m.default);
      const { userActions } = await import('../redux/user/user.slice');
      store.store.dispatch(userActions.logout());
      return Promise.reject(error);
    }
    return Promise.reject(error);
  },
);
